import React from 'react';
import { CONTEXT_PROVIDERS } from '../../../utils/constants';
import AuthFormContext from '../../AuthForm/AuthFormContext';
import RegistrationInfoFormContext from '../../RegistrationInfoForm/RegistrationInfoFormContext';
import RestoreFormContext from '../../../containers/RestorePassword/RestoreFormContext';
import ResetFormContext from '../../../containers/ResetPassword/ResetFormContext';
import CreateAppFormContext from '../../../containers/CreateApp/components/Form/CreateAppFormContext';
import CreateCampaignFormContext from '../../../containers/CreateCampaign/components/CreateCampaignForm/CreateCampaignFromContext';
import InvoiceFormContext from '../../InvoiceForm/InvoiceFormContext';
import TextField from '../TextField/TextField';
import UserFormContext from '../../UserForm/UserFormContext';
import PasswordFormContext from '../../../containers/UserScreen/components/PasswordModal/PasswordFormContext';
import RefillFormContext from '../../_molecules/RefillBalance/RefillBalanceContext';
import CreateAdminModalContext from '../../_molecules/CreateAdminModal/CreateAdminModalContext';
/* using this wrapper to use field with react context
* in this case with AuthForm
* for the future - will create dynamic import of Context wrapper.
*/
export default (props) => {
  switch (props.contextProvider) {
    case (CONTEXT_PROVIDERS.AuthFormContext):
    {
      return (
        <AuthFormContext.Consumer >
          {({ register, changeHandler, focusHandler }) => (<TextField
            {...props}
            registerField={register}
            changeHandler={changeHandler}
            focusHandler={focusHandler}
          />)}

        </AuthFormContext.Consumer>
      );
    }
    case (CONTEXT_PROVIDERS.CreateAdminModalContext):
    {
      return (
        <CreateAdminModalContext>
          {({ register, changeHandler, focusHandler }) => (<TextField
            {...props}
            registerField={register}
            changeHandler={changeHandler}
            focusHandler={focusHandler}
          />)}
        </CreateAdminModalContext>
      );
    }
    case (CONTEXT_PROVIDERS.RegistrationInfoFormContext):
      return (
        <RegistrationInfoFormContext.Consumer>
          {({ register, changeHandler, focusHandler }) => (<TextField
            {...props}
            registerField={register}
            changeHandler={changeHandler}
            focusHandler={focusHandler}
          />)}
        </RegistrationInfoFormContext.Consumer>
      );
    case (CONTEXT_PROVIDERS.RestoreFormContext):

      return (
        <RestoreFormContext.Consumer>
          {({ register, changeHandler, focusHandler }) => (<TextField
            {...props}
            registerField={register}
            changeHandler={changeHandler}
            focusHandler={focusHandler}
          />)}
        </RestoreFormContext.Consumer>
      );
    case (CONTEXT_PROVIDERS.ResetFormContext):

      return (
        <ResetFormContext.Consumer>
          {({ register, changeHandler, focusHandler }) => (<TextField
            {...props}
            registerField={register}
            changeHandler={changeHandler}
            focusHandler={focusHandler}
          />)}
        </ResetFormContext.Consumer>
      );
    case (CONTEXT_PROVIDERS.CreateAppFormContext):
      return (
        <CreateAppFormContext.Consumer>
          {({ register, changeHandler, focusHandler }) => (<TextField
            {...props}
            registerField={register}
            changeHandler={changeHandler}
            focusHandler={focusHandler}
          />)}
        </CreateAppFormContext.Consumer>
      );
    case (CONTEXT_PROVIDERS.CreateCampaignFormContext):

      return (
        <CreateCampaignFormContext.Consumer>
          {({ register, changeHandler, focusHandler }) => (<TextField
            {...props}
            registerField={register}
            changeHandler={changeHandler}
            focusHandler={focusHandler}
          />)}
        </CreateCampaignFormContext.Consumer>
      );
    case (CONTEXT_PROVIDERS.InvoiceFormContext):
      return (
        <InvoiceFormContext.Consumer>
          {({ register, changeHandler, focusHandler }) => (<TextField
            {...props}
            registerField={register}
            changeHandler={changeHandler}
            focusHandler={focusHandler}
          />)}
        </InvoiceFormContext.Consumer>
      );
    case (CONTEXT_PROVIDERS.UserFormContext):
      return (
        <UserFormContext.Consumer>
          {({ register, changeHandler, focusHandler }) => (<TextField
            {...props}
            registerField={register}
            changeHandler={changeHandler}
            focusHandler={focusHandler}
          />)}
        </UserFormContext.Consumer>
      );
    case (CONTEXT_PROVIDERS.PasswordFormContext):
      return (
        <PasswordFormContext.Consumer>
          {({ register, changeHandler, focusHandler }) => (<TextField
            {...props}
            registerField={register}
            changeHandler={changeHandler}
            focusHandler={focusHandler}
          />)}
        </PasswordFormContext.Consumer>
      );
    case (CONTEXT_PROVIDERS.RefillFormContext):
      return (
        <RefillFormContext.Consumer>
          {({ register, changeHandler, focusHandler }) => (<TextField
            {...props}
            registerField={register}
            changeHandler={changeHandler}
            focusHandler={focusHandler}
          />)}
        </RefillFormContext.Consumer>
      );
    default:
    {
      return <TextField {...props} />;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_atomic/ConnectedTextField/ConnectedTextField.js